import { message } from "antd";
import axiosBackEnd from "../../config/axios/axios-back-end";
import * as actionTypes from "./actionTypes";
import { apiStart, apiComplete, apiFail } from "./api";

export const qchmgGetSuccess = (data) => {
  return {
    type: actionTypes.QC_HMG_GET_SUCCESS,
    data,
  };
};

export const qchotelGetSuccess = (data) => {
  return {
    type: actionTypes.QC_HOTEL_GET_SUCCESS,
    data,
  };
};
export const reportQcSuccess = (data) => {
  return {
    type: actionTypes.QC_REPORTS_QC_SUCCESS,
    data,
  };
};
export const envelopTriggerSuccess = (data) => {
  return {
    type: actionTypes.QC_ENVLOP_TRIGR_SUCCESS,
    data,
  };
};

export const qcEnvironImpactGetSuccess = (data) => {
  return {
    type: actionTypes.QC_ENVIRON_IMPACT_GET_SUCCESS,
    data: data.result,
  };
};

/* export const updateEnvironImpactSuccess = data =>{
  return {
    type: actionTypes.QC_UPDATE_ENVIRON_IMPACT_SUCCESS,
    data: data.result
  }
} */

export const completeLoading = () => {
  return async (dispatch) => {
    dispatch(apiComplete());
    return true;
  };
};

export const startLoading = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    return true;
  };
};

export const updateEnvironmentImpact = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post(
        "/api/qcapp/updateEnvironmentImpact",
        data,
        { headers },
      );
      // dispatch(updateEnvironImpactSuccess(response.data));
      message.success(response.data.message);
      dispatch(apiComplete());
      return true;
    } catch (err) {
      if (err.response) {
        const { errors } = err.response.data;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const getEnvironImpactVal = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get(
        "/api/qcapp/getEnvironImpact",
        null,
        { headers },
      );
      dispatch(qcEnvironImpactGetSuccess(response.data));
      response.data.error == true
        ? message.error(response.data.message)
        : message.success(response.data.message);
      dispatch(apiComplete());
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};
export const requestReportQc = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/qcapp/reportQc", data, {
        headers,
      });
      dispatch(apiComplete());
      dispatch(reportQcSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const { errors } = err.response.data;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const triggerEnvelop = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/qcapp/triggerEnvp", data, {
        headers,
      });
      dispatch(apiComplete());
      dispatch(envelopTriggerSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      message.error(err.response.data.message);

      dispatch(apiFail(err.response.data.message));

      return false;
    }
  };
};

export const qchmgGet = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/qcapp/qchmg", null, {
        headers,
      });
      dispatch(apiComplete());
      dispatch(qchmgGetSuccess(response.data));

      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }

      return false;
    }
  };
};
export const qchotelGet = (id) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const encodedId = encodeURIComponent(id);
      const response = await axiosBackEnd.get(
        `/api/qcapp/qchotels?mgmGroup=${encodedId}`,
        null,
        { headers },
      );
      dispatch(apiComplete());
      dispatch(qchotelGetSuccess(response.data));
      return true;
    } catch (err) {
      if (err.response) {
        const { errors } = err.response.data;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};
